import { takeLatest, call, put, all, debounce } from "redux-saga/effects";
import {
  CREATE_AGENT,
  UPDATE_AGENT,
  DELETE_AGENT,
  GET_AGENT,
  INTERACT_WITH_AGENT,
  interactWithAgentSuccess,
  interactWithAgentFailure,
} from "../actions/agentActions";
import {
  createAgentSuccess,
  createAgentFailure,
  updateAgentSuccess,
  updateAgentFailure,
  deleteAgentSuccess,
  deleteAgentFailure,
  getAgentSuccess,
  getAgentFailure,
} from "../actions/agentActions";
import {
  createAgentApi,
  updateAgentApi,
  deleteAgentApi,
  getAgentApi,
  interactWithAgentApi,
} from "../apis/agentApi";

// Saga to handle creating an agent configuration
function* initiateCreateAgent(action) {
  try {
    console.log(
      `PMM - SF - agentSaga.js - initiateCreateAgent - action is: ${JSON.stringify(
        action
      )}`
    );

    const agentInput = action.payload;
    console.log(
      `PMM - SF - agentSaga.js - initiateCreateAgent - agentInput is: ${JSON.stringify(
        agentInput
      )}`
    );

    const response = yield call(createAgentApi, agentInput);
    console.log(
      `PMM - SF - agentSaga - response is: ${JSON.stringify(response)}`
    );
    // Dispatch the success action with the returned agent configuration
    yield put(createAgentSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(createAgentFailure(error.message));
  }
}

// Saga to handle updating an agent configuration
function* initiateUpdateAgent(action) {
  try {
    const response = yield call(updateAgentApi, action.payload);
    // Dispatch the success action with the updated agent configuration
    yield put(updateAgentSuccess(response.agent));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(updateAgentFailure(error.message));
  }
}

// Saga to handle deleting an agent configuration
function* initiateDeleteAgent(action) {
  try {
    const response = yield call(deleteAgentApi, action.payload);
    // Dispatch the success action with a success message
    yield put(deleteAgentSuccess(response.message));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(deleteAgentFailure(error.message));
  }
}

// Saga to handle retrieving an agent configuration
function* initiateGetAgent(action) {
  try {
    const { tenantId, agentId } = action.payload;
    const response = yield call(getAgentApi, tenantId, agentId);
    // Dispatch the success action with the retrieved agent configuration
    yield put(getAgentSuccess(response.agent));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(getAgentFailure(error.message));
  }
}

// Saga to handle agent interaction
function* initiateAgentInteraction(action) {
  try {
    const { tenantId, agentId, message } = action.payload;
    const response = yield call(interactWithAgentApi, {
      tenantId,
      entityId: agentId,
      message,
    });
    yield put(interactWithAgentSuccess(response));
  } catch (error) {
    yield put(interactWithAgentFailure(error.message));
  }
}

// Watcher saga for creating an agent
function* watchInitiateCreateAgent() {
  yield takeLatest(CREATE_AGENT, initiateCreateAgent);
}

// Watcher saga for updating an agent
function* watchInitiateUpdateAgent() {
  yield takeLatest(UPDATE_AGENT, initiateUpdateAgent);
}

// Watcher saga for deleting an agent
function* watchInitiateDeleteAgent() {
  yield takeLatest(DELETE_AGENT, initiateDeleteAgent);
}

// Watcher saga for retrieving an agent configuration
function* watchInitiateGetAgent() {
  yield takeLatest(GET_AGENT, initiateGetAgent);
}

// Watcher saga for agent interaction
function* watchInitiateAgentInteraction() {
  yield debounce(300, INTERACT_WITH_AGENT, initiateAgentInteraction);
}

// Root saga that bundles all agent watchers
export default function* agentSaga() {
  yield all([
    watchInitiateCreateAgent(),
    watchInitiateUpdateAgent(),
    watchInitiateDeleteAgent(),
    watchInitiateGetAgent(),
    watchInitiateAgentInteraction(),
  ]);
}
